module.exports = __webpack_public_path__ + "img/panel_pv_power_on.28f45adb.png";